import React from 'react'

import Immutable from 'immutable'
import PropTypes from 'prop-types'
import { ReactReduxContext } from 'react-redux'

import { OrderBoxSize } from './OrderBoxSize'
import OrderCancelButton from './OrderCancelButton'
import OrderDelivery from './OrderDelivery'
import OrderPricingDetail from './OrderPricingDetail'
import OrderProducts from './OrderProducts'
import OrderRecipes from './OrderRecipes'

import css from './OrderDetail.css'

class OrderDetail extends React.PureComponent {
  render() {
    const {
      recipesPeriodStockFetchError,
      orderDeliveryDaysFetchError,
      recipes,
      orderId,
      orderDeliveryDate,
      orderState,
      products,
      whenCutoff,
      portionsCount,
      paymentDate,
      priceBreakdown,
      deliveryDate,
      rawDeliveryDate,
      deliveryTimeStart,
      deliveryTimeEnd,
      editDeliveryMode,
      cancellable,
      deliveryDayId,
      deliveryDay,
      periodId,
      maxNumRecipes,
    } = this.props
    const fetchSuccess =
      recipesPeriodStockFetchError === null && orderDeliveryDaysFetchError === null

    return (
      <div className={css.orderDetail} data-testing="orderDetail">
        {orderState === 'recipes chosen' ? (
          <section className={css.openCardSection}>
            <OrderBoxSize
              portionsCount={portionsCount}
              orderId={orderId}
              orderDeliveryDate={orderDeliveryDate}
            />
          </section>
        ) : null}
        {['menu open', 'recipes chosen', 'confirmed', 'dispatched'].indexOf(orderState) > -1 ? (
          <section className={css.openCardSection}>
            <OrderRecipes
              recipes={recipes}
              orderId={orderId}
              orderState={orderState}
              whenCutoff={whenCutoff}
              periodId={periodId}
              portionsCount={portionsCount}
              deliveryDate={rawDeliveryDate}
              maxNumRecipes={maxNumRecipes}
            />
          </section>
        ) : null}
        {orderState === 'recipes chosen' ? (
          <>
            <section className={css.openCardSection}>
              <OrderProducts orderId={orderId} products={products} />
            </section>
          </>
        ) : null}
        {['recipes chosen', 'confirmed', 'dispatched'].indexOf(orderState) > -1 ? (
          <section className={css.openCardSection}>
            <OrderPricingDetail
              paymentDate={paymentDate}
              numberOfRecipes={recipes.size}
              priceBreakdown={priceBreakdown}
            />
          </section>
        ) : null}
        {['menu open', 'recipes chosen', 'confirmed', 'dispatched'].indexOf(orderState) > -1 ? (
          <section className={css.openCardSection}>
            <OrderDelivery
              date={deliveryDate}
              timeStart={deliveryTimeStart}
              timeEnd={deliveryTimeEnd}
              orderState={orderState}
              orderId={orderId}
              editDeliveryMode={editDeliveryMode}
              orderDeliveryDaysFetchError={orderDeliveryDaysFetchError}
              recipesPeriodStockFetchError={recipesPeriodStockFetchError}
              fetchSuccess={fetchSuccess}
            />
          </section>
        ) : null}
        {cancellable && orderState !== 'cancelled' ? (
          <section className={css.openCardSection}>
            <OrderCancelButton
              orderId={orderId}
              deliveryDayId={deliveryDayId}
              orderState={orderState}
              deliveryDay={deliveryDay}
            />
          </section>
        ) : null}
      </div>
    )
  }
}

OrderDetail.propTypes = {
  orderId: PropTypes.string,
  orderDeliveryDate: PropTypes.string,
  deliveryDayId: PropTypes.string,
  orderState: PropTypes.string,
  paymentDate: PropTypes.string,
  recipes: PropTypes.instanceOf(Immutable.List),
  products: PropTypes.instanceOf(Immutable.List),
  priceBreakdown: PropTypes.instanceOf(Immutable.Map),
  deliveryDate: PropTypes.string,
  rawDeliveryDate: PropTypes.string,
  deliveryTimeStart: PropTypes.string,
  deliveryTimeEnd: PropTypes.string,
  whenCutoff: PropTypes.string,
  editDeliveryMode: PropTypes.bool,
  cancellable: PropTypes.bool,
  orderDeliveryDaysFetchError: PropTypes.string,
  recipesPeriodStockFetchError: PropTypes.string,
  deliveryDay: PropTypes.string,
  portionsCount: PropTypes.string,
  periodId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxNumRecipes: PropTypes.number,
}

OrderDetail.contextType = ReactReduxContext

OrderDetail.defaultProps = {
  orderId: '',
  orderDeliveryDate: '',
  deliveryDayId: '',
  orderState: '',
  paymentDate: '',
  recipes: Immutable.List([]),
  products: Immutable.List([]),
  priceBreakdown: Immutable.Map({}),
  deliveryDate: '',
  rawDeliveryDate: '',
  deliveryTimeStart: '',
  deliveryTimeEnd: '',
  whenCutoff: '',
  editDeliveryMode: false,
  cancellable: false,
  orderDeliveryDaysFetchError: '',
  recipesPeriodStockFetchError: '',
  deliveryDay: '',
  portionsCount: '2',
  periodId: '',
  maxNumRecipes: 4,
}

export default OrderDetail
